import {
  Button,
  CascaderSelect,
  Dialog,
  Form,
  Input,
  Message,
  Select,
  Table,
} from '@alifd/next';
import { Tag } from 'antd';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const ResidentScanType = () => {
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const users = client.service('users');
  const [accountNumberArr, setAccountNumberArr] = useState([]);
  const [userAccountArr, setUserAccountArr] = useState([]);
  const [dataSourceSelect, setDataSourceSelect] = useState(null);
  const [userActiveDialog, setUserActiveDialog] = useState(false);
  const [userActiveCheckDialog, setUserActiveCheckDialog] = useState(false);
  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [rfidDialog, setRfidDialog] = useState(false);
  const [rfidDisplay, setRfidDisplay] = useState('');
  const [usersEmail, setUsersEmail] = useState('');
  const [usersName, setUsersName] = useState('');
  const [usersEmailData, setUsersEmailData] = useState([]);
  const [editingHouse, setEditingHouse] = useState(null);

  // HouseholdAccountNumber table

  // 查詢
  function residentFind(para) {
    return new Promise((resolve, reject) => {
      try {
        residentAccountNumbers.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  // 新增
  function residentCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        residentAccountNumbers.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  // 更新
  function residentUpdate(id, obj, params) {
    return new Promise((resolve, reject) => {
      // console.log(id, obj, params)
      residentAccountNumbers
        .patch(id, obj, params)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  // 刪除
  function residentRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        residentAccountNumbers.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  function householdNumberSort(a, b) {
    return a.building.localeCompare(b.building);
  }
  // 刷新頁面
  function serverDataUpdate() {
    residentFind({}).then((result) => {
      console.log(result.sort(householdNumberSort));
      setAccountNumberArr(result.sort(householdNumberSort));
    });
  }

  // User find
  function userAccountFind() {
    users
      .find({
        query: {
          f_password: { $exists: false },
          expireTime: { $exists: false },
        },
      })
      .then((result) => {
        setUserAccountArr(result.data);
      });
  }

  // 更新
  function userUpdate(id, obj, params) {
    return new Promise((resolve, reject) => {
      // console.log(id, obj, params)
      users
        .patch(id, obj, params)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  useEffect(() => {
    serverDataUpdate();
    userAccountFind();
  }, []);

  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = accountNumberArr.map((i) => i.householdNumber.split('-'));
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childsObj = {};
      newStages[e].forEach((ee, nb) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childsObj[ee] = {
          // 'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].forEach((ee, nb) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') !== -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childsObj[ky].children) {
            // 加入到上一層children
            childsObj[ky].children = [childsObj[ee]];
          } else {
            childsObj[ky].children.push(childsObj[ee]);
            // childsObj[ky].children.sort((a, b) => {
            //   return a.label - b.label;
            // }); // label小－大
          }
        }
      });
      FinalData.push(childsObj[Object.keys(childsObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    return FinalData;
  }

  const selectAccountNumberArr = useMemo(
    () =>
      accountNumberArr.filter((account) =>
        dataSourceSelect ? account.householdNumber === dataSourceSelect : true
      ),
    [accountNumberArr, dataSourceSelect]
  );

  const getSortedAccountNumberArr = () => {
    const householdNumbers = selectAccountNumberArr.map((accountNumber) => {
      return accountNumber.householdNumber;
    });
    const sortedHouseholdNumber = householdNumbers.sort();
    const sortedAccountNumberArr = [];
    for (let x in sortedHouseholdNumber) {
      for (let y in selectAccountNumberArr) {
        if (
          sortedHouseholdNumber[x] === selectAccountNumberArr[y].householdNumber
        ) {
          sortedAccountNumberArr.push(selectAccountNumberArr[y]);
        }
      }
    }
    sortedAccountNumberArr.sort((a, b) => {
      if (a.building + a.floorChild === b.building + b.floorChild) {
        return (
          a.householdNumber.substring(3, a.householdNumber.length - 1) -
          b.householdNumber.substring(3, b.householdNumber.length - 1)
        );
      }
      return 0;
    });
    return sortedAccountNumberArr;
  };

  const sortedAccountNumberArr = getSortedAccountNumberArr();

  return (
    <>
      <Form.Item label="戶號">
        <CascaderSelect
          placeholder="請選擇戶號"
          dataSource={ParseStringToArrayObject()}
          value={dataSourceSelect}
          onChange={(value) => {
            setDataSourceSelect(value);
          }}
        />
        <Button
          style={{ marginLeft: '10px' }}
          onClick={() => setDataSourceSelect(null)}
        >
          清除
        </Button>
      </Form.Item>

      <Table dataSource={sortedAccountNumberArr}>
        <Table.Column
          title="狀態"
          dataIndex="members"
          width={50}
          cell={(value) => {
            if (value?.length > 0) {
              return <Tag color="green">已開通</Tag>;
            } else {
              return <Tag color="red">未開通</Tag>;
            }
          }}
        />
        <Table.Column title="戶號" dataIndex="householdNumber" width={100} />
        <Table.Column
          title="成員"
          width={200}
          cell={(_val, _index, record) => {
            return (
              <>
                {record.householdNumber
                  ? userAccountArr
                      .filter(
                        (i) =>
                          Object.hasOwn(i, 'householdNumbers') &&
                          i.householdNumbers.includes(record.householdNumber)
                      )
                      .map((user, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              margin: '5px',
                            }}
                          >
                            <p>
                              {user.name}/{user.email}
                            </p>
                            <Button
                              style={{ marginLeft: '15px' }}
                              type="normal"
                              warning
                              onClick={() => {
                                Swal.fire({
                                  title: `確定刪除成員\n(${user.name}/${user.email})\n資料?`,
                                  text: '刪除後將無法復原!!',
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: '#3085d6',
                                  cancelButtonColor: '#BEBEBE',
                                  confirmButtonText: '確定',
                                  cancelButtonText: '取消',
                                  width: 'fit-content',
                                  customClass: styles.swalModalTitle,
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    Swal.fire(
                                      '刪除!',
                                      '此成員已刪除',
                                      'success'
                                    );
                                    userUpdate(user._id, {
                                      $pull: {
                                        householdNumbers:
                                          record.householdNumber,
                                      },
                                    })
                                      .then((res) => {
                                        Message.success('刪除成功');
                                        serverDataUpdate();
                                        userAccountFind();
                                        console.log(
                                          '==users delete householdNumbers success:',
                                          res
                                        );
                                      })
                                      .catch((error) => {
                                        console.log(
                                          '==users delete householdNumbers fail:',
                                          error
                                        );
                                      });
                                  }
                                });
                              }}
                            >
                              刪除
                            </Button>
                          </div>
                        );
                      })
                  : ''}
              </>
            );
          }}
        />
        <Table.Column
          title="更新時間"
          width={100}
          cell={(_, index) => {
            return (
              <p>
                {moment(sortedAccountNumberArr[index].updatedTime).format(
                  'YYYY-MM-DD HH:mm:ss'
                )}
              </p>
            );
          }}
        />
        <Table.Column
          title="操作"
          width={100}
          lock="right"
          cell={(_, _2, record) => {
            return (
              <div className={styles.btn}>
                <Button
                  type="normal"
                  onClick={() => {
                    setUserActiveDialog(true);
                    setEditingHouse(record);
                  }}
                >
                  開通住戶成員
                </Button>
              </div>
            );
          }}
        />
      </Table>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userActiveCheckDialog}
        onOk={() => {
          users
            .patch(
              null,
              {
                $addToSet: {
                  householdNumbers: editingHouse.householdNumber,
                },
              },
              { query: { email: usersEmail } }
            )
            .then((res) => {
              Message.success('開通成功');
              serverDataUpdate();
              userAccountFind();
              console.log('==residentAccountNumbers update success:', res);
            })
            .catch((error) => {
              console.log('==residentAccountNumbers update fail:', error);
            });
          setUserActiveCheckDialog(false);
          setEditingHouse(null);
        }}
        onCancel={() => {
          setUserActiveCheckDialog(false);
          setEditingHouse(null);
        }}
        onClose={() => {
          setUserActiveCheckDialog(false);
          setEditingHouse(null);
        }}
      >
        <h1>確認開通用戶</h1>
        {usersEmailData.map((list, index) => {
          return (
            <div key={index}>
              <h2>姓名:{list.name ? list.name : '尚未設定'}</h2>
              <h2>帳號:{list.email}</h2>
            </div>
          );
        })}
      </Dialog>

      <Dialog
        hasMask
        className={styles.dialog}
        visible={userActiveDialog}
        onOk={() => {
          try {
            if (usersEmail !== '') {
              users
                .find({ query: { email: usersEmail } })
                .then((res) => {
                  console.log('==users find success:', res.data);
                  setUsersEmailData(res.data);
                })
                .catch((error) => {
                  console.log('==rusers find fail:', error);
                });
              setBarcodeDisplay('');
              setRfidDisplay('');
              setUserActiveDialog(false);
              setUserActiveCheckDialog(true);
            } else {
              Message.error('無此條碼或磁扣碼');
              setUserActiveDialog(true);
            }
          } catch (error) {
            console.log(error);
            setUserActiveDialog(true);
          }
        }}
        onCancel={() => {
          setBarcodeDisplay('');
          setRfidDisplay('');
          setUserActiveDialog(false);
        }}
        onClose={() => {
          setBarcodeDisplay('');
          setRfidDisplay('');
          setUserActiveDialog(false);
        }}
      >
        <h1>請掃描用戶掃描APP條碼</h1>

        <img
          width={300}
          height={200}
          src="/ezcon/img/Barcode.svg"
          type="cover"
          style={{
            border: '1px solid #ccc',
            margin: '10px',
            backgroundColor: '#0188CC',
          }}
          onClick={() => {
            setBarcodeDialog(true);
          }}
          alt="掃描用戶條碼或磁扣"
        />
        <div>值:{barcodeDisplay}</div>

        <Dialog
          hasMask
          visible={barcodeDialog}
          footer={false}
          onClose={() => {
            setBarcodeDisplay('');
            setBarcodeDialog(false);
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setBarcodeDisplay(data);
                  Message.success('掃描成功');
                  setBarcodeDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setBarcodeDialog(true);
                }
                users
                  .find({
                    query: {
                      barcodeType: data,
                    },
                  })
                  .then((res) => {
                    console.log('==users find success:', res.data[0]);
                    setUsersEmail(res.data[0].email);
                    setUsersName(res.data[0].name);
                  })
                  .catch((error) => {
                    console.log('==rusers find fail:', error);
                    setUsersEmail('');
                    setUsersName('');
                  });
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="barcodeDisplay"
                value={barcodeDisplay}
                onChange={(value) => {
                  setBarcodeDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(barcodeDisplay)) {
                    Message.success('掃描成功');
                    setBarcodeDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setBarcodeDialog(true);
                  }
                  users
                    .find({
                      query: {
                        barcodeType: barcodeDisplay,
                      },
                    })
                    .then((res) => {
                      console.log('==users find success:', res.data[0]);
                      setUsersEmail(res.data[0].email);
                      setUsersName(res.data[0].name);
                    })
                    .catch((error) => {
                      console.log('==rusers find fail:', error);
                      setUsersEmail('');
                      setUsersName('');
                    });
                }}
              />
            </Item>
            <br />
            <img
              src="/ezcon/img/Barcode.svg"
              alt="barcode"
              type="cover"
              width={400}
              height={300}
              style={{
                margin: '10px',
                backgroundColor: '#0088cc',
              }}
            />

            <h1>請掃描條碼...</h1>
          </Form>
        </Dialog>

        {/* <img
          width={300}
          height={200}
          src="/ezcon/img/Rfid.jpg"
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setRfidDialog(true);
          }}
          alt="掃描條碼"
        />
        <div>值:{rfidDisplay}</div> */}

        {/* <Dialog
          hasMask
          visible={rfidDialog}
          footer={false}
          onClose={() => {
            setRfidDialog(false);
            setRfidDisplay('');
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setRfidDisplay(data);
                  Message.success('掃描成功');
                  setRfidDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setRfidDialog(true);
                }
                users
                  .find({
                    query: {
                      rfidType: data,
                    },
                  })
                  .then((res) => {
                    console.log('==users find success:', res.data[0]);
                    setUsersEmail(res.data[0].email);
                    setUsersName(res.data[0].name);
                  })
                  .catch((error) => {
                    console.log('==rusers find fail:', error);
                    setUsersEmail('');
                    setUsersName('');
                  });
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="rfidDisplay"
                value={rfidDisplay}
                onChange={(value) => {
                  setRfidDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(rfidDisplay)) {
                    Message.success('掃描成功');
                    setRfidDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setRfidDialog(true);
                  }
                  users
                    .find({
                      query: {
                        rfidType: rfidDisplay,
                      },
                    })
                    .then((res) => {
                      console.log('==users find success:', res.data[0]);
                      setUsersEmail(res.data[0].email);
                      setUsersName(res.data[0].name);
                    })
                    .catch((error) => {
                      console.log('==rusers find fail:', error);
                      setUsersEmail('');
                      setUsersName('');
                    });
                }}
              />
            </Item>

            <br />
            <img
              className={styles.barcode}
              src="/ezcon/img/Rfid.jpg"
              alt="rfid"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描磁扣/卡片...</h1>
          </Form>
        </Dialog> */}
      </Dialog>
    </>
  );
};

export default ResidentScanType;
